export default __webpack_public_path__ + "static/Moderat-Medium-66c5910d942444542cf2d548ecc5caad.woff2";